import React from 'react';

interface TimelineProps {}

export const Timeline: React.FC<React.PropsWithChildren<TimelineProps>> = ({ children }) => {
  return <>{children}</>;
};
